import RoleLimitation from './RoleLimitation';

export default RoleLimitation;
